export default {"src":"/_next/static/media/icon-6.63a01245.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};